import { createFileRoute } from '@tanstack/react-router';
import FileNumberEdit from '../../../features/baseData/fileNumbers/fileNumber/edit';
import {
  createPermissionGuard,
  FILE_NUMBERS_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/aktenzeichen/$fileNumberId_/bearbeiten',
)({
  component: FileNumberEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(FILE_NUMBERS_PERMISSIONS, 'EDIT'),
  ),
});

export const EditFileNumberRoute = Route;
